<template>
    <div>
        <nav class="tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-p-3 tw-shadow-md bg-white tw-shadow-md">
            <div class="tw-flex tw-items-center tw-flex-shrink-0 tw-text-white tw-mr-6 tw-ml-20">
                <span class="tw-ml-10 tw-font-semibold tw-text-xl tw-tracking-tight">
                    <router-link to="/" class="text-white">
                        <img src="../assets/logo.svg" class="tw-h-16" alt="logo" >
                    </router-link>
                </span>
            </div>
            <button
                class="tw-bg-transparent hover:tw-bg-green-500 tw-text-green-700 tw-font-semibold hover:tw-text-white tw-px-16 tw-py-3 tw-rounded tw-border-2 tw-border-green-500 tw-mr-10 tw-outline-none"
                @click="route"
            >
                LOGIN
            </button>
        </nav>

        <div class="tw-flex tw-flex-wrap tw-px-4 lg:tw-px-40 tw-mt-8">
            <div class="tw-w-full lg:tw-w-1/3 tw-bg-white tw-mt-12">
                <div class="Box border-0">
                    <h1 class="text-green tw-font-semibold">
                        ALL YOUR MESSAGING PROBLEMS SOLVED!
                    </h1>
                    <p class="text-gray">
                        Our online solution can solve your messaging problems, Whether it be fax, email, SMS or voice broadcasting, MyPortal is a self service platform
                        that caters for them all.
                    </p>
                    <img
                        src="../assets/images/hero.png"
                        alt=""
                        class="tw-w-full tw-px-32 lg:tw-px-0"
                    >
                </div>
            </div>
            <div class="tw-w-full lg:tw-w-2/3 tw-bg-white tw-mt-12 tw-px-0 lg:tw-px-12">
                <div class="Box border-0 tw-shadow p-6 text-gray tw-tracking-wide">
                    <form @submit.prevent="register">
                        <div>
                            <div class="Box-row py-1">
                                <h2>
                                    CREATE YOUR ACCOUNT
                                </h2>
                            </div>
                            <div class="Box-row py-1 border-0">
                                <div class="container-lg gutter clearfix">
                                    <div class="col-6 float-left">
                                        <div class="form-group">
                                            <dt>
                                                <label for="firstName">First Name</label>
                                            </dt>
                                            <dd>
                                                <input
                                                    class="form-control"
                                                    id="firstName"
                                                    name="firstName"
                                                    type="text"
                                                    v-model="firstName"
                                                    required
                                                />
                                            </dd>
                                        </div>
                                    </div>
                                    <div class="col-6  float-left">
                                        <div class="form-group">
                                            <dt>
                                                <label for="lastName">Last Name</label>
                                            </dt>
                                            <dd>
                                                <input
                                                    class="form-control"
                                                    id="lastName"
                                                    name="lastName"
                                                    type="text"
                                                    v-model="lastName"
                                                    required
                                                />
                                            </dd>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="Box-row py-1 border-0">
                                <div class="container-lg gutter clearfix">
                                    <div class="col-6 float-left">
                                        <div class="form-group">
                                            <dt>
                                                <label for="phoneNumber">Phone Number</label>
                                            </dt>
                                            <dd>
                                                <input
                                                    class="form-control input-lg"
                                                    id="phoneNumber"
                                                    name="phoneNumber"
                                                    placeholder="0412 345 678"
                                                    v-model="phoneNumber"
                                                    type="number"
                                                />
                                            </dd>
                                        </div>
                                    </div>
                                    <div class="col-6 float-left">
                                        <div class="form-group">
                                            <dt>
                                                <label for="email">Email</label>
                                            </dt>
                                            <dd>
                                                <input
                                                    class="form-control"
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    v-model="email"
                                                    required
                                                />
                                            </dd>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="Box-row py-1 border-0">
                                <div class="container-lg gutter clearfix">
                                    <div class="col-6 float-left">
                                        <div
                                            class="form-group"
                                            :class="!validPassword ? 'warn' : ''"
                                        >
                                            <dt>
                                                <label for="password">Password</label>
                                            </dt>
                                            <dd>
                                                <input
                                                    class="form-control input-lg"
                                                    id="password"
                                                    name="password"
                                                    type="password"
                                                    v-model="password"
                                                    required
                                                />
                                            </dd>
                                            <dd v-if="!validPassword" class="warning anim-fade-in">The password must contain atleast 8 characters</dd>
                                        </div>
                                    </div>
                                    <div class="col-6 float-left">
                                        <div
                                            class="form-group"
                                            :class="!validConfirm ? 'errored' : ''"
                                        >
                                            <dt>
                                                <label for="confirmPassword">Confirm Password</label>
                                            </dt>
                                            <dd>
                                                <input
                                                    class="form-control"
                                                    id="confirmPassword"
                                                    name="confirmPassword"
                                                    type="password"
                                                    required
                                                    v-model="confirmPassword"
                                                />
                                            </dd>
                                            <dd v-if="!validConfirm" class="error anim-fade-in">The passwords do not match</dd>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="Box-row py-1 border-0">
                                <div class="container-lg gutter clearfix">
                                    <div class="col-6 float-left">
                                        <div class="form-group">
                                            <dt>
                                                <label for="timezone">Timezone</label>
                                            </dt>
                                            <dd>
                                                <select
                                                    class="form-select btn-block"
                                                    name="timezone"
                                                    id="timezone"
                                                    required
                                                >
                                                    <option value="adl"> Adelaide </option>
                                                </select>
                                            </dd>
                                        </div>
                                    </div>
                                    <div class="col-6 float-left">
                                        <div class="form-group">
                                            <dd class="tw-mt-12">
                                                <div class="form-checkbox">
                                                    <label>
                                                      <input
                                                        type="checkbox"
                                                        aria-describedby="help-text-for-checkbox"
                                                        required
                                                    />
                                                        I accept the <span class="text-green">Terms and Conditions</span>
                                                    </label>
                                                </div>
                                            </dd>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="Box-row py-1 border-0 text-center mt-3">
                                <button
                                    class="tw-bg-green-600 tw-text-white tw-font-semibold tw-px-32 tw-py-3 tw-rounded"
                                >
                                    REGISTER
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            email: "",
            password: "",
            lastName: "",
            firstName: "",
            phoneNumber: "",
            validConfirm: true,
            validPassword: true,
            confirmPassword: "",
        }
    },
    methods: {
        route() {
            this.$router.push("/login");
        },
        register() {
            if (!this.validPassword) return;
            if (!this.validConfirm) return;

            const registerPayload = {
                email: this.email,
                password: this.password,
                firstName: this.firstName,
                lastName: this.lastName,
                phoneNumber: this.phoneNumber,
            }

            this.$store.dispatch("register", registerPayload)
                .then( _ => {
                    this.$router.push('/message_type');
                })
        },
    },
    created() {
        document
            .getElementsByTagName("body")
            .item(0)
            .classList
            .toggle('tw-bg-white')
        ;
    },
    watch: {
        password() {
            if (this.password.length < 8)
                this.validPassword = false
            else
                this.validPassword = true;
        },
        confirmPassword() {
            if (this.confirmPassword !== this.password)
                this.validConfirm = false;
            else
                this.validConfirm = true;
        }
    }
}
</script>
